import httpB2b from "../Components/HttpB2B";
import { encryptData } from "./encryptDecrypt";
import http from "../Components/HttpCommon";
import httpAll from "../Components/HttpCommonALL";
import axios from "axios";

class B2BServices {
  elasticUrl = process.env.REACT_APP_API_ES_URL;

  constructor() {
    this.apiUrl = process.env.REACT_APP_API_ES_URL;
    this.commonUrl = process.env.REACT_APP_API_COMMON_URL;
    this.newUrl = process.env.REACT_APP_NEW;
  }

  async getB2BLists(payload) {
    try {
      const response = await httpB2b.post(
        `order/getAllOrdersWithoutItems`,
        payload,
      );
      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async getPartners(payload) {
    try {
      const response = await httpB2b.post(`Partner/getAll`, payload);
      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }

  async getB2BDetails(payload) {
    try {
      const response = await httpB2b.post(`order/getOrderItemDetails`, payload);
      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async transferOrder(payload) {
    try {
      const response = await httpB2b.post(`order/transfer-order`, payload);

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async searchMedicine(payload) {
    const params = new URLSearchParams(payload).toString();
    const url = `${this.elasticUrl}?${params}`;
    try {
      const response = await httpB2b.get(url);
      return response.data;
    } catch (error) {
      console.error("Search Medicine Error:", error);
      return null;
    }
  }
  async postB2BPartners(payload) {
    try {
      const response = await httpB2b.post(`order/updateConfirmOrders`, payload);
      return response.data;
    } catch (error) {
      console.error("Search Medicine Error:", error);
      return null;
    }
  }
  async submittB2BPartners(payload) {
    try {
      const response = await httpB2b.post(`order/updateOrders`, payload);
      return response.data;
    } catch (error) {
      console.error("Search Medicine Error:", error);
      return null;
    }
  }
  async recomendedMedicine(payload) {
    const params = new URLSearchParams(payload).toString();
    const url = `${this.elasticUrl}genericMedicines?${params}`;
    try {
      const response = await httpB2b.get(url);
      return response.data;
    } catch (error) {
      console.error("Search Medicine Error:", error);
      return null;
    }
  }
  async createConsignment(payload, source, useSamplify) {
    try {
      const sourceChannel = source === "B2B" ? "B2B" : "B2C";
      const samplifyParam =
        typeof useSamplify === "boolean" ? `&useSamplify=${useSamplify}` : "";
      const response = await httpAll.post(
        `consignment/create-consignment-id?sourceChannel=${sourceChannel}${samplifyParam}`,
        payload,
      );
      return response.data;
    } catch (error) {
      console.error("Search Medicine Error:", error);
      return null;
    }
  }
  async packConsignment(payload) {
    try {
      const response = await axios.put(
        `${this.newUrl}api/v1/rider/packed`,
        payload,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error in packedConsignment:",
        error?.response?.data || error.message,
      );
      throw error;
    }
  }
}

const b2bService = new B2BServices();
export default b2bService;
